import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/lib/auth'
import LoadingSpinner from '@/components/LoadingSpinner'

interface AdminRouteProps {
  children: React.ReactNode
}

/**
 * Route-level guard for admin-only pages.
 * Shows loading spinner while auth is initializing,
 * redirects non-admins to home page.
 */
export default function AdminRoute({ children }: AdminRouteProps) {
  const { user, isLoading } = useAuthStore()

  if (isLoading) {
    return (
      <div className="min-h-[400px] flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  if (!user?.root_admin) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
